import { Box } from 'components/Box';
import { FieldLabel as Label } from 'components/_form/FieldLabel';
import { Flex } from 'components/Flex';
import { P } from 'components/Typography/Typography';
import { DefaultTFuncReturn } from 'i18next';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Switch from 'react-switch';
import styled from 'styled-components';

/** Jedna wartość steruje „sztucznym pogrubieniem” (0 = brak, 0.25 = delikatnie, 0.5 = mocniej). */
const FAKE_BOLD = 0.1;
const stroke = FAKE_BOLD * 1.4;
const shadow = FAKE_BOLD;

const StyledP = styled(P)`
  padding: 7px;
  text-transform: capitalize;
  font-weight: 700;
  -webkit-text-stroke: ${stroke}px currentColor;
  text-shadow:
    ${shadow}px 0 0 currentColor,
    0 ${shadow}px 0 currentColor,
    -${shadow}px 0 0 currentColor,
    0 -${shadow}px 0 currentColor;
`;

const HelperText = styled(P)`
  text-align: right;
  font-style: oblique;
  width: 100%;
`;

interface Props {
  /** Label nad przełącznikiem (jak w Select) */
  label?: string | DefaultTFuncReturn | null;
  /** Tekst pomocniczy pod etykietą (jak w Select) */
  helperText?: string | DefaultTFuncReturn;
  /** Bez marginesu dolnego (jak withoutMargin w Select) */
  withoutMargin?: boolean;
  onChange?: (state: boolean) => void;
  value?: boolean;
  disabled?: boolean;
}

export const SwitchButton: FC<Props> = ({
  label,
  helperText,
  withoutMargin,
  value,
  onChange,
  disabled
}) => {
  const [checked, setChecked] = useState(!!value);
  const { t } = useTranslation();

  useEffect(() => {
    setChecked(!!value);
  }, [value]);

  const switchControl = (
    <Switch
      disabled={disabled}
      checked={checked}
      onChange={() => {
        setChecked((prevChecked) => {
          const newChecked = !prevChecked;
          onChange?.(newChecked);
          return newChecked;
        });
      }}
      checkedIcon={
        <StyledP variant="body2" color="white">
          {t('common.yes')}
        </StyledP>
      }
      uncheckedIcon={
        <StyledP variant="body2" color="white">
          {t('common.no')}
        </StyledP>
      }
    />
  );

  if (label) {
    return (
      <Box mb={!withoutMargin ? 3 : undefined} width="100%">
        <Flex justifyContent="space-between">
          <Label>{typeof label === 'string' ? t(label) : label}</Label>
          {helperText && (
            <HelperText variant="body">{t(helperText)}</HelperText>
          )}
        </Flex>
        {switchControl}
      </Box>
    );
  }

  return (
    <Flex justifyContent="space-between" flexWrap="wrap" alignItems="center">
      {switchControl}
    </Flex>
  );
};
